import React from 'react';
import { Snackbar, Button, Alert } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useServiceWorker } from '../../contexts/ServiceWorkerContext';

const UpdateNotification: React.FC = () => {
  const { isUpdateAvailable, updateApp } = useServiceWorker();

  return (
    <Snackbar
      open={isUpdateAvailable}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ bottom: { xs: 90, sm: 24 } }} // Account for mobile nav
    >
      <Alert
        severity="info"
        variant="filled"
        sx={{
          width: '100%',
          alignItems: 'center',
          '& .MuiAlert-message': {
            display: 'flex',
            alignItems: 'center',
            gap: 2,
          },
        }}
        action={
          <Button
            color="inherit"
            size="small"
            onClick={updateApp}
            startIcon={<RefreshIcon />}
            sx={{
              fontWeight: 600,
              backgroundColor: 'rgba(255,255,255,0.2)',
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.3)',
              },
            }}
          >
            Update Now
          </Button>
        }
      >
        A new version is available!
      </Alert>
    </Snackbar>
  );
};

export default UpdateNotification;
